import { render } from "./TableHeaderComponent.vue?vue&type=template&id=4933df76&scoped=true"
import script from "./TableHeaderComponent.vue?vue&type=script&lang=js"
export * from "./TableHeaderComponent.vue?vue&type=script&lang=js"

import "./TableHeaderComponent.vue?vue&type=style&index=0&id=4933df76&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4933df76"]])

export default __exports__